import React, { useState } from 'react';
import ButtonsGeneric from '../../../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../../../components/NovoSistema/ContainerSection';
import { WrapperInputsNewSystem } from '../../../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import ButtonOptions from '../../../../../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../../../../../components/NovoSistema/HeaderButtons';
import DoubleInput from '../../../../../../../../components/NovoSistema/DoubleInput';

export default function UsoEConsumoFilter() {
  const [option, setOption] = useState('Filtro');
  return (
    <div>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Filtro"
          border="#DFB007"
          active={option === 'Filtro' ? true : false}
          yourFunction={() => setOption('Filtro')}
        />
      </HeaderButtons>
      {option === 'Filtro' && (
        <ContainerSection>
          <WrapperInputsNewSystem>
            <DoubleInput title="Produto" id="Produto" widthPercentage="45%" />
            <DoubleInput title="Localização" id="Localizacao" widthPercentage="45%" />
          </WrapperInputsNewSystem>
          <ButtonsGeneric>
            <button className="normal">Limpar</button>
          </ButtonsGeneric>
        </ContainerSection>
      )}
    </div>
  );
}
